// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"ErrorPage_mainContainer__14iYH","sideImage":"ErrorPage_sideImage__J6JGj","actionButton":"ErrorPage_actionButton__fNkFw","mainColumn":"ErrorPage_mainColumn__1ANxN"};